import {
    CHANGE_FORGOT_CONFIRM,
    CHANGE_FORGOT_PASSWORD,
    CHANGE_FORGOT_PHONE,
    CHANGE_FORGOT_VALIDATE,
    ERROR_FORGOT_CONFIRM,
    INITIAL_FORGOT,
    SHOW_FORGOT_CONFIRM,
    SHOW_FORGOT_PASSWORD,
    SUBMIT_FORGOT_PASSWORD,
    SUBMIT_FORGOT_PHONE,
    SUBMIT_FORGOT_VALIDATION
} from "./type";

const initiate = {
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    errorPhoneNumber: "",
    errorPassword: "",
    errorSubmit: "",
    validate: {
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
        otp5: '',
        otp6: '',
    },
    submitProgress: false,
    phoneSubmitted: false,
    isSubmited: false,
    showPassword: false,
    showConfirmPassword: false,
    tempToken: "",
}

const ForgotPasswordReducer = (state = initiate, action) => {
    switch (action.type) {
        case INITIAL_FORGOT:
            state = initiate;

            return state;
        case CHANGE_FORGOT_PHONE:
            return {
                ...state,
                ...action.payload
            };
        case CHANGE_FORGOT_VALIDATE:
            const otp = action.payload;

            const validate = {
                ...state.validate,
                ...otp
            }

            return {
                ...state,
                validate
            };
        case SUBMIT_FORGOT_PHONE:
            return {
                ...state,
                ...action.payload
            };
        case SUBMIT_FORGOT_PASSWORD:
            return {
                ...state,
                ...action.payload
            };
        case SUBMIT_FORGOT_VALIDATION:
            return {
                ...state,
                ...action.payload
            };
        case CHANGE_FORGOT_CONFIRM:
            return {
                ...state,
                ...action.payload
            };
        case ERROR_FORGOT_CONFIRM:
            return {
                ...state,
                ...action.payload
            };
        case CHANGE_FORGOT_PASSWORD:
            return {
                ...state,
                ...action.payload
            };
        case SHOW_FORGOT_CONFIRM:
            return {
                ...state,
                ...action.payload
            };
        case SHOW_FORGOT_PASSWORD:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export default ForgotPasswordReducer;